import React from "react";
import LoginForm from "../../components/AccountsForm/Login/LoginForm";

const Login = () => {
  return (
    <>
      <LoginForm />
    </>
  );
};
export default Login;
